<mat-dialog-content>
    <div class="hypo-dialog-header">
        <div class="hypo-dialog-title">
            <mat-icon>account_balance_wallet</mat-icon>
            <div>Úprava bankovního účtu</div>
        </div>

        <button mat-dialog-close type="button" [attr.data-testid]="'bank-account-dialog-button-close'">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <form [formGroup]="accountDialogForm" [attr.data-testid]="'back-account-dialog'" class="hypo-dialog-content">
        <h4>Základní údaje</h4>
        <div class="flex flex-col md:flex-row md:gap-4">
            <app-hypo-select [label]="'Banka'" [listName]="'bank'" formControlName="bankCode" class="w-full">
            </app-hypo-select>
            <app-hypo-input
                [inputmode]="'text'"
                [label]="'Kód banky'"
                [readOnly]="true"
                [suffixTemplate]="bankCodeSuffixTemplate"
                formControlName="bankCodeDisplay"
                class="w-44">
                <ng-template #bankCodeSuffixTemplate>
                    <div class="input-info input-action">
                        <app-tooltip
                            [icon]="'lock'"
                            [text]="'Kód banky se mění automaticky při výběru banky.'"
                            class="inline-icon-grey">
                        </app-tooltip>
                    </div>
                </ng-template>
            </app-hypo-input>
        </div>

        @if (showMore) {
            <div class="flex flex-col md:flex-row md:gap-4">
                <app-hypo-input
                    [inputmode]="'decimal'"
                    [label]="'Předčíslí bankovního účtu'"
                    [mask]="'000000'"
                    formControlName="numberBefore"
                    class="w-full md:w-2/5">
                </app-hypo-input>
                <app-hypo-input
                    [inputmode]="'decimal'"
                    [label]="'Číslo bankovního účtu'"
                    [mask]="'0000000000'"
                    formControlName="numberAfter"
                    class="w-full md:w-3/5">
                </app-hypo-input>
            </div>
        }

        @if (showMore) {
            <div class="flex flex-row gap-4">
                <div class="home-bank flex flex-col justify-start items-start gap-3">
                    <mat-label>Domovská banka</mat-label>
                    <mat-slide-toggle formControlName="isHomeBank" [attr.data-testid]="'isHomeBank'">
                    </mat-slide-toggle>
                </div>
            </div>
        }
    </form>

    <div class="hypo-dialog-footer">
        <button
            (click)="continue()"
            class="btn btn-lg orange bank-account-dialog-button-continue"
            mat-button
            type="button"
            [attr.data-testid]="'bank-account-dialog-button-continue'">
            Pokračovat
        </button>
    </div>
</mat-dialog-content>
